import { render, staticRenderFns } from "./select-manager.vue?vue&type=template&id=04dd4d30&scoped=true&"
import script from "./select-manager.vue?vue&type=script&lang=js&"
export * from "./select-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd4d30",
  null
  
)

export default component.exports